<div class="container-fluid" style="padding: 0px; max-height: 98vh">
  <header>
    <nav
      class="navbar navbar-expand-md navbar-dark fixed-top"
      style="background: #020202"
    >
      <a class="navbar-brand mnav" href="#"
        ><img src="../assets/images/logowhite.svg" style="height: 48px"
      /></a>
    </nav>
  </header>
  <div class="logout-text">
    <p *ngIf="isUserPermissionError">
      You do not have permissions to access Control Centre. Please contact the
      Administrator at your organisation to grant you permissions. Please click
      <a [routerLink]="['/login']">here</a> to try again.
    </p>
    <p *ngIf="isUserSettingError">
      We have identified an issue with your permissions to access Control
      Centre. Please contact Everlight support to resolve the problem. Click
      <a [routerLink]="['/login']">here</a> to log back in.
    </p>
    <p *ngIf="isNormalLogout">
      You have been logged out of Control Centre. Click
      <a [routerLink]="['/login']">here</a> to log back in.
    </p>
  </div>
</div>
